'use strict';

module.exports = '_sugar_';